import { ContactComment } from "../../interfaces/DTO/crm/contactComment";
import { contactCommentService } from "../../services/crm/contactCommentService";
import { createCachedEntityHooks } from "../createEntityHooks";

// ✅ hook-ים גנריים עם cache לפי contact_id בלבד
export const {
  useEntityListByField:useEntityListByField,
  useCreateEntity: useCreateContactComment,
  useUpdateEntity: useUpdateContactComment,
  usePartialUpdateEntity: usePartialUpdateContactComment,
  useDeleteEntity: useDeleteContactComment,
} = createCachedEntityHooks<ContactComment>({
  entityName: "contactComments",
  service: contactCommentService,
  enableCacheById: false, // אין צורך ב־cache לפי id
  fieldIndexes: {
    contact_id: () => (contactId) => contactCommentService.getByContactId(contactId),
  },
  staleTimeMs: 5000,
});

export const useContactCommentsByContactId = (contactId: number, enabled: boolean = true) =>
  useEntityListByField("contact_id", contactId);